import React,{useContext,useEffect, useState, useRef, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { getRequest, postRequest, deleteRequest } from '../../api/ApiController';
import { PrintIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from 'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css';
import UtilContext from '../../components/UtilContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { showDeactivatedInLists, filterTrainingEmployees } from '../../utils/moduleSettings';
import ReactDOMServer from 'react-dom/server';
import "../../assets/css/docviewer.css";
import "@cyntler/react-doc-viewer/dist/index.css";
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT } from '../../utils/tabulatorAuditColumns';
import { Avatar } from 'primereact/avatar';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { LocaleContext } from '../../components/LocaleContext';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';

export default function TrainingEmployeeDetail({training_type, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { t } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,openFilePreview,getDateFormat, openChosenNotificationPreferences} = useContext(UtilContext);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const overlayRef = useRef(null);
    /** Aby by_training/{id} nebol volaný dvakrát pri rovnakom id (Strict Mode / double mount). */
    const loadingByTrainingIdRef = useRef(null);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({'employee.name':true,'employee.department.name':true,custom_last_training_date:true,custom_next_training_date:true,custom_employee_status:true,custom_state:true,
      custom_company_name:true,custom_machine_name:true,custom_lecturer_name:true,custom_company_contact_name:true,created_at:true,updated_at:true
    });
    const defaultColumnsVisible = {'employee.name':true,'employee.department.name':true,custom_last_training_date:true,custom_next_training_date:true,custom_employee_status:true,custom_state:true,custom_company_name:true,custom_machine_name:true,custom_lecturer_name:true,custom_company_contact_name:true,created_at:true,updated_at:true};
    const resetMask = () => resetTabulatorMask({ page: 'TrainingEmployeeDetail', defaultColumnsVisible, ref, columns, setColumnsVisible });
    const [maskVisible, setMaskVisible] = useState(false);
const [formTrainingType,setFormTrainingType] = useState(training_type);
    const [trainingTypesList, setTrainingTypesList] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    useEffect(() => {
        setLoadingData(true);
        getRequest("/api/training_types?minimal=1")
            .then((r) => setTrainingTypesList(r?.data ?? r ?? []))
            .catch(() => {})
            .finally(() => setLoadingData(false));
    }, []);
    const [formType, setFormType] = useState(type);

    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit training"))?false:true);

    const [images,setImages] = useState('');
    const [loadingDetailTable, setLoadingDetailTable] = useState(true);
    const loadingDetailTableRef = useRef(loadingDetailTable);
    loadingDetailTableRef.current = loadingDetailTable;
    /** Len karty pre aktuálne vybrané školenie (formTrainingType.id) – nie celých 3k+ záznamov */
    const [detailTableData, setDetailTableData] = useState([]);

    // Načítanie len kariet pre jedno školenie (by_training) – rýchle oproti plnému load; ref bráni dvojitému volaniu
    useEffect(() => {
        const id = formTrainingType?.id;
        if (id == null) {
            setDetailTableData([]);
            setLoadingDetailTable(false);
            return;
        }
        if (loadingByTrainingIdRef.current === id) return;
        loadingByTrainingIdRef.current = id;
        setLoadingDetailTable(true);
        getRequest(`/api/training_employees/by_training/${id}`)
            .then((r) => setDetailTableData(r?.data ?? []))
            .catch(() => setDetailTableData([]))
            .finally(() => { setLoadingDetailTable(false); loadingByTrainingIdRef.current = null; });
    }, [formTrainingType?.id]);

    useEffect(() => {
        if (formTrainingType != null) {
            getImages();
        }
    }, [formTrainingType]);

    useEffect(() => {
        if (loadingDetailTable) {
            const t = ref.current;
            if (t?.initialized) t.alert?.(t('Common.LoadingEllipsis'));
        } else {
            ref.current?.clearAlert?.();
        }
    }, [loadingDetailTable]);

    const reloadData = () => {
        if (formTrainingType?.id == null) return;
        setLoadingDetailTable(true);
        getRequest(`/api/training_employees/by_training/${formTrainingType.id}`)
            .then((r) => setDetailTableData(r?.data ?? []))
            .catch(() => setDetailTableData([]))
            .finally(() => setLoadingDetailTable(false));
    };

    const showDeactivated = showDeactivatedInLists(state.module_settings, 'training');
    const tableData = useMemo(
        () => filterTrainingEmployees(detailTableData, showDeactivated),
        [detailTableData, showDeactivated]
    );
    const tabulatorOptions = useMemo(() => ({
        renderHorizontal: 'virtual',
        rowHeight: TABULATOR_AUDIT_MIN_ROW_HEIGHT,
        movableColumns: true,
        resizableColumnFit: true,
        dataTree: true,
        dataTreeStartExpanded: false,
        dataTreeFilter: false,
        dataTreeElementColumn: 'employee.name',
        dataTreeCollapseElement: ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon />),
        dataTreeExpandElement: ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon />),
        dataTreeBranchElement: ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon />),
        printAsHtml: true,
        printRowRange: 'active',
        printCopyStyle: true,
        layout: 'fitColumns',
        initialFilter: [{ field: 'training_id', type: '=', value: formTrainingType?.id ?? training_type?.id }],
        printHeader: function () {
            const ft = formTrainingType;
            const bodyHtml = ReactDOMServer.renderToStaticMarkup(
                <div>
                    <div className="mt-6">
                        <div className="md:grid grid-cols-2 gap-1 mb-2">
                            <div className="mb-2">
                                <label htmlFor="name" className="block text-left text-lg font-semibold text-gray-800">{t('Common.Name')}</label>
                                <input name="name" type="text" value={ft?.name ?? ''} style={{ fontSize: '1rem', width: '100%', padding: '2px 4px 2px 4px' }} className="border rounded-md" readOnly />
                            </div>
                            <div>
                                <label htmlFor="department_id" className="block text-left text-lg font-semibold text-gray-800">{t('Common.Department')}</label>
                                <select name="department_id" value={ft?.department_id ?? ''} style={{ fontSize: '1rem', width: '100%', height: '42px', padding: '4px 4px 4px 4px' }} className="border rounded-md">
                                    <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                                    {(state.departments || []).map((d) => (<option key={d.id} value={d.id}>{d.name}</option>))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="mt-6">
                        <div className="md:grid grid-cols-2 gap-4 mb-2">
                            <div className="mb-2">
                                <label htmlFor="type" className="block text-left text-lg font-semibold text-gray-800">Druh</label>
                                <input name="type" type="text" value={ft?.type ?? ''} style={{ fontSize: '1rem', width: '100%', padding: '2px 4px 2px 4px' }} className="border rounded-md" readOnly />
                            </div>
                            <div>
                                <label htmlFor="interval" className="block text-left text-lg font-semibold text-gray-800">Interval v mesiacoch</label>
                                <input name="interval" type="text" value={ft?.interval ?? ''} style={{ fontSize: '1rem', width: '100%', padding: '2px 4px 2px 4px' }} className="border rounded-md" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
            );
            return buildCanonicalPrintHeaderHtml({
                branding: state?.branding,
                productFallbackSrc: defaultProductLogoSrc,
                companySettingsPrint: state?.company_settings_print,
                moduleSettings: state?.module_settings,
                title: t('Print.Title.TrainingEmployeeDetail'),
                printDateLabel: t('Print.DateLabel'),
                bodyHtml,
            });
        },
        printFooter: function () {
            return buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print });
        },
    }), [formTrainingType, training_type, state.departments, state?.branding, state?.company_settings_print, state?.module_settings, t]);

    function getImages(id=null){
        getRequest(`/api/training_types/protocols/${id ? id : formTrainingType.id}`).then((response) => {
            if(response.data!=="{}")setImages(response.data);
        });
    }

    const normalizeText = (value) => (value || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    function textHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = všetko
        return normalizeText(rowValue).includes(normalizeText(headerValue));
    }

    function employeeDepartmentHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const name = String(rowData.employee?.department?.name ?? rowValue ?? '').trim();
        return normalizeText(name).includes(normalizeText(headerValue));
    }

    function companyNameHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const name = String(rowData.company?.name ?? rowValue ?? '').trim();
        return normalizeText(name).includes(normalizeText(headerValue));
    }

    function NameFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='training_name'>{rowData.employee?.name}</div>;
    }

    function employeeHeaderFilter(headerValue, rowValue, rowData, filterParams) {
      if(headerValue!=""){
          return rowData.employee?.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(headerValue.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
      }
    } 

    function LastTrainingDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].last_training_date).toFormat(dateFmt);
        if(rowData?.last_training_date) return DateTime.fromISO(rowData?.last_training_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
    }

    function NextTrainingDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].next_training_date).toFormat(dateFmt);
        if(rowData?.next_training_date) return DateTime.fromISO(rowData?.next_training_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
    }

    function machineHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData.machines?.length<0)return false;
        else return rowData.machines.map(machine => machine?.name).join('/').toLowerCase().includes(headerValue.toLowerCase());
    }

    function MachineFormatter(props){
        const rowData = props.cell.getRow().getData();
        console.log(rowData.machines);
        return rowData.machines?.map(machine => machine?.name)?.join('/');
    }

    function lecturerHeaderFilter(headerValue, rowValue, rowData, filterParams){
        return rowData.lecturer?.name.toLowerCase().includes(headerValue.toLowerCase()) || rowData.company_contact?.lecturer?.name.toLowerCase().includes(headerValue.toLowerCase());
    }

    function LecturerFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData?.lecturer?.name || rowData?.company_contact?.lecturer?.name;
    }

    function contactHeaderFilter(headerValue, rowValue, rowData, filterParams){
        return rowData?.company_contact?.name.toLowerCase().includes(headerValue.toLowerCase()) || rowData?.company_contact?.employee?.name.toLowerCase().includes(headerValue.toLowerCase());
    }

    function ContactFormatter(props){
        const rowData = props.cell.getRow().getData();
        return rowData?.company_contact?.name || rowData?.company_contact?.employee?.name;
    }

    function StateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==0){
                        if(parent._row.data?.deactivation_date!=null && parent._row.data?.deactivation_date!=""){
                            return "DEA";
                        }
                        else if(new Date(parent_array[i]?.next_training_date) < new Date()){
                            return "NOK";
                        }
                        else return "OK";
                    }
                    else return "OK";
                }
            }
        }
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="") return "DEA";
        if(rowData?._children?.length > 0){           
            if(new Date(rowData?._children[0]?.next_training_date) < new Date()){
                return "NOK";
            }
            return "OK"
        }
        else if(new Date(rowData?.initial_date) > new Date()){
            return "OK";
        }
        else return "NOK";
    }

    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if(rowData?._children?.length==0){
        if(headerValue!=""){
            if(new Date(rowData?.initial_date) > new Date())return t('Common.Scheduled').toLowerCase().includes(headerValue.toLowerCase());
            return t('TrainingRecordDetail.Text.Neskoleny').toLowerCase().includes(headerValue.toLowerCase());
        }
        }
        if(filterParams.name=="last_training_date"){
        return DateTime.fromISO(rowData?._children[0]?.last_training_date).toFormat(dateFmt).includes(headerValue);
        }
        else if(filterParams.name=="next_training_date"){
        return DateTime.fromISO(rowData?._children[0]?.next_training_date).toFormat(dateFmt).includes(headerValue);
        }
    }

    function stateHeaderFilter(headerValue, rowValue, rowData, filterParams){
        let state = "";
        if(rowData?._children?.length > 0){
            if(new Date(rowData?._children[0]?.next_training_date) < new Date()){
                state="NOK";
            }
            else state="OK";
        }
        else if(new Date(rowData?.initial_date) > new Date()){
            state="OK";
        }
        else state="NOK";
        if((rowData?.deactivation_date!=null && rowData?.deactivation_date!="") || (rowData?.employee?.date_of_departure!=null && rowData?.employee?.date_of_departure!=""))state="DEA";
        if(headerValue=="OK NOK")return headerValue.toUpperCase().includes(state.toUpperCase());
        return headerValue.toUpperCase() == state.toUpperCase();
    }

    function EmployeeStatusFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const isActive = !rowData?.employee?.date_of_departure || rowData?.employee?.date_of_departure === "";
        return <span className={isActive ? '' : 'text-red-600'}>{isActive ? 'Aktívne' : t('Common.Deactivated')}</span>;
    }

    function employeeStatusHeaderFilter(headerValue, rowValue, rowData, filterParams) {
        const isActive = !rowData?.employee?.date_of_departure || rowData?.employee?.date_of_departure === "";
        const rowLabel = isActive ? 'Aktívne' : t('Common.Deactivated');
        return headerValue === rowLabel;
    }
      


    function ParentChildAuditFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const field = props.cell.getColumn().getField();
        // Parent TrainingCard: blank/N/A provenance (Package B parity). Child TrainingRecord: truthful.
        const isChild = !!(rowData?.training_card_id > 0);
        if (!isChild) return <span></span>;
        const raw = rowData?.[field];
        let text = '';
        if (raw) {
          try {
            const dt = DateTime.fromISO(String(raw));
            text = dt.isValid ? dt.toFormat(`${dateFmt} HH:mm`) : String(raw);
          } catch (_e) { text = String(raw); }
        }
        const user = field === 'created_at'
          ? (rowData?.created_by_user || rowData?.createdByUser)
          : (rowData?.updated_by_user || rowData?.updatedByUser);
        if (!text && !user) return <span></span>;
        const name = user?.employee?.name || user?.username || '';
        return <span>{[name, text].filter(Boolean).join(' ')}</span>;
    }

    const [columns,setColumns] = useState([
        // Tabulator 5.5.2: first non-frozen column flips later frozen cols to RIGHT.
        // Keep hidden id frozen so rowSelection/editor stay LEFT-frozen with the tree column.
        { title: '', field: 'id', visible:false, frozen:true, print:false },
        { field: 'rowSelection', formatter:'rowSelection', titleFormatter:'rowSelection', hozAlign:'center', width:44, minWidth:44, headerSort:false, resizable:false, frozen:true, print:false, download:false },
        { title: '', field: 'editor', width:44, minWidth:44, headerSort:false, resizable:false, frozen:true, print:false, download:false, visible:false },
        { title: 'Meno', field: 'employee.name',formatter: reactFormatter(<NameFormatter/>),headerFilter:"input",headerFilterFunc:employeeHeaderFilter,minWidth: 200,widthGrow:2},
        { title: t('Common.Department'), field: 'employee.department.name', minWidth: 200, headerFilter: "input", headerFilterFunc: employeeDepartmentHeaderFilter, resizable: false },
        { title: t('Common.LastTraining'), field: 'custom_last_training_date',headerFilter:"input",minWidth: 200,formatter: reactFormatter(<LastTrainingDate/>),headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"last_training_date"},resizable:false},
        { title: t('Common.NextTraining'), field: 'custom_next_training_date',headerFilter:"input",minWidth: 200,formatter: reactFormatter(<NextTrainingDate/>),headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"next_training_date"},resizable:false},
        { title: t('Common.EmployeeStatus'), field: 'custom_employee_status',headerFilter:"list", headerFilterParams:{values:{"Aktívne":"Aktívne",[t('Common.Deactivated')]:t('Common.Deactivated')}, clearable:true},headerFilterFunc:employeeStatusHeaderFilter,formatter: reactFormatter(<EmployeeStatusFormatter/>),minWidth: 140,resizable:false},
        { title: t('Common.Status'), field: 'custom_state',minWidth: 200,formatter: reactFormatter(<StateFormatter/>),headerFilter:"list", headerFilterParams:{values:{"OK NOK":"OK NOK","OK":"OK","NOK":"NOK"}, clearable:true},headerFilterFunc:stateHeaderFilter,resizable:false},
        { title: t('Common.TrainingCompanyShort'), field: 'company.name', headerFilter: "input", headerFilterFunc: companyNameHeaderFilter, minWidth: 200 },
        { title: 'Stroj', field: 'custom_machine_name',headerFilter:"input",headerFilterFunc:machineHeaderFilter,minWidth: 200,formatter: reactFormatter(<MachineFormatter/>),},
        { title: 'Lektor', field: 'custom_lecturer_name',headerFilter:"input",headerFilterFunc:lecturerHeaderFilter,minWidth: 200,formatter: reactFormatter(<LecturerFormatter/>),},
        { title: t('Common.Trainer'), field: 'custom_company_contact_name',headerFilter:"input",headerFilterFunc:contactHeaderFilter,minWidth: 200,formatter: reactFormatter(<ContactFormatter/>),},
        { title: t('TrainingRecordDetail.Text.Zalozenie_zaznamu'), field: 'created_at', minWidth: 180, headerSort: false, formatter: reactFormatter(<ParentChildAuditFormatter/>) },
        { title: t('TrainingRecordDetail.Text.Posledna_aktivita_zaznamu'), field: 'updated_at', minWidth: 180, headerSort: false, formatter: reactFormatter(<ParentChildAuditFormatter/>) },
    ]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            ref.current.hideColumn(`${val}`);
          }
          else{
            ref.current.showColumn(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
        setTimeout(() => {
          ref.current.redraw(true);
      }, 0);
      }

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("TrainingEmployeeDetail","set_filters",null,ref.current.getHeaderFilters(),null);},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("TrainingEmployeeDetail","set_filters",null,[],null);ref.current.clearHeaderFilter();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("TrainingEmployeeDetail","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("TrainingEmployeeDetail","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5b',
                label: t('Common.ResetUserMask'),
                icon: 'pi pi-refresh',
                command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingEmployeeDetail');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(trainingTypesList, formTrainingType?.id, setFormTrainingType),
        [trainingTypesList, formTrainingType?.id]
    );

      function changeMarkings(value){
        const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
        if(columnVisible[val]!=="specific_id" || columnVisible[val]!=="editor"|| columnVisible[val]!=="end_of_validity"){
            columnVisible[val]=value;
            ref.current.hideColumn(`${val}`);
        }
        };
        setColumnsVisible(columnVisible);
        setTimeout(() => {
            ref.current.redraw(true);
        }, 0);
      }

      function initFilter(data, filterParams){
        return !data.employee.date_of_departure && !data.deactivation_date
      }

    if (loadingData) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-177px)] bg-gray-100 gap-4">
                <InfinitySpin width="120" color="#333" />
                <span className="text-gray-700">{t('Common.LoadingEllipsis')}</span>
            </div>
        );
    }

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => ref.current.print(false,true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => reloadData()} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('TrainingEmployeeDetail.Text.Detail_Skolenia'),"TrainingEmployeeDeatil")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("TrainingEmployeeDetail",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
    <SplitterPanel className="flex align-items-center justify-content-center overflow-y-auto" minSize={10} size={20}>
        <div className="w-full relative flex flex-col overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2'>
          <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.ZOZNAM_ZAMESTNANCOV_SKOLENIA')}</h1>
                <div className="flex flex-wrap items-center gap-4 mt-1">
                  <label className="block text-md font-semibold text-gray-800">Por.č.: {formTrainingType?.id}</label>
                </div>
                <div className="mt-4">
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Name')}</label>
                        <input
                            name='name'
                            type="text"
                            value={formTrainingType?.name} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="department_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Department')}</label>
                        <select 
                        name='department_id'
                        value={formTrainingType?.department_id} disabled
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {(state.departments || []).map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                        </select>
                        </div>  
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                    <div>
                        <label
                            htmlFor="type"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Druh
                        </label>
                        <input
                            name='type'
                            type="text"
                            value={formTrainingType?.type} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="interval"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >
                            Interval v mesiacoch
                        </label>
                        <input
                            name='interval'
                            type="number"
                            value={formTrainingType?.interval} readOnly
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div className="mt-4">
                        <label htmlFor="status" className="block text-md font-semibold text-gray-800">{t('Common.TrainingStatus')}</label>
                        <input
                            name="status"
                            type="text"
                            readOnly
                            value={formTrainingType?.status == null || formTrainingType?.status === '' || formTrainingType?.status === 'Aktívny' ? 'Aktívne' : 'Zrušené'}
                            className={`block w-full px-4 py-2 mt-2 rounded-md border focus:ring focus:ring-opacity-40 ${(formTrainingType?.status === 'Zrušený') ? 'bg-red-50 border-red-200 text-red-700' : 'bg-green-50 border-green-200 text-green-700'}`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="images"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Predloha:
                        </label>
                        {images!=='' && images.map((img) => (<table className='w-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                            <tr>
                                <td className='text-black h-10'><div className='flex flex-row p-2'>
                                    <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>
                                        {img.filename.includes(".docx") ?<img src={require('./../../assets/img/word.png')} style={{ height: '65px', width: 'auto'}} alt="Word Logo"/> : <embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>}
                                    </div>
                                        <div className='flex flex-col ml-4'>
                                        <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                        </div>
                                    </div></td>
                            </tr>
                        </table>))}
                        </div>
                    </div>
                </div> 
            </div>
             </SplitterPanel>
             <SplitterPanel className="flex flex-col align-items-center justify-content-center w-full h-full overflow-y-auto" size={40} style={{minHeight: '110px'}}>
             <ReactTabulator
      data={tableData} 
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        tableBuilt: ()=>{
          ref.current.addFilter(initFilter);
          if (loadingDetailTableRef.current) ref.current.alert?.(t('Common.LoadingEllipsis'));
          let mask = state.user_mask_filters.filter(mask => mask.page=="TrainingEmployeeDetail");
          const safeParse = (v, fallback) => {
              if (v === null || v === undefined) return fallback;
              if (typeof v === "string") {
              try { return JSON.parse(v); } catch { return fallback; }
              }
              return v; // už je array/object
          };
          if (mask.length > 0) {
              const attributes  = safeParse(mask[0].attributes, []);
              const filters     = safeParse(mask[0].filters, []);
              const sorters     = safeParse(mask[0].sorters, []);
              const json_columns = safeParse(mask[0].columns, {});
              if (Array.isArray(attributes) && attributes.length > 1) {
                  ref.current.setColumnLayout(attributes);
              }
              if (Array.isArray(filters)) {
                  filters.forEach(f => ref.current.setHeaderFilterValue(f.field, f.value));
              }
              if (Array.isArray(sorters) && sorters.length > 0) {
                  ref.current.setSort(sorters);
              }
              if (json_columns && typeof json_columns === "object") {
                  setColumnsVisible(json_columns);
                  for (let column in json_columns) {
                      if (json_columns[column] === false) ref.current.hideColumn(column);
                      else ref.current.showColumn(column);
                  }
              }
          }
        },
        columnMoved: () => { setUserMaskFilter("TrainingEmployeeDetail", "column_move", null, null, ref.current.getColumnLayout()); },
        columnResized: () => { setUserMaskFilter("TrainingEmployeeDetail", "column_resized", null, null, ref.current.getColumnLayout()); },
      }}
      className='h-full w-full' //176px h-[calc(100vh_-_176px)]
      options={tabulatorOptions}
    />
    </SplitterPanel>
    </Splitter> 
            <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingEmployeeDeatil","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
            </div>
            </> 
            );
} 
